









































import { Component, Ref, Vue } from 'vue-property-decorator'

import getSearchDefine from './search'
import getTableDefine from './table'
import getModalDefine from './modal'

import { PagerData } from '@/libs/request/request'
import service, { GenealogyApply } from '@/api/genealogy/GenealogyApply'
import serviceEntrust, { GenealogyApplyByEntrust } from '@/api/genealogy/GenealogyApplyByEntrust'

import IForm from '@/libs/formHelper/form/form.vue'
import IModalForm from '@/libs/formHelper/modalForm/modalForm.vue'
import IPagerTable from '@/libs/tableHelper/pagerTable.vue'

@Component({
  components: {
    IForm,
    IPagerTable,
    IModalForm
  }
})
export default class extends Vue {
  query: any = {
    page: 1,
    pageSize: 10,
    type: 1,
    sorts: ['createTime']
  }

  // 表格数据
  tabledata: PagerData<GenealogyApply> = {
    total: 0,
    items: []
  }

  loading: boolean = true

  showModal: boolean = false

  selectItem: GenealogyApply = {}

  // 表格列定义
  get tableDefine () {
    return getTableDefine(this)
  }

  get searchDefine () {
    return getSearchDefine(this)
  }

  get modalDefine () {
    return getModalDefine(this)
  }

  @Ref('modal')
  modalRef?: IModalForm<GenealogyApply>

  created () {
    this.freshFromServer()
  }

  agreeHandle (item: GenealogyApply) {
    this.selectItem = item
    return service.updateOneGenealogyApply(item.id!).then(() => {
      this.$Message.success('操作成功')
      this.freshFromServer()
    })
  }

  rejectHandle (item: any) {
    this.selectItem = item
    return service.deleteOneGenealogyApply(item.id).then(() => {
      this.$Message.success('操作成功')
      this.freshFromServer()
    })
  }

  fetchDataFromServer (
    curPage: number | undefined = undefined,
    pageSize: number | undefined = undefined
  ) {
    if (curPage) {
      this.query.page = curPage
    }
    if (pageSize) {
      this.query.pageSize = pageSize
    }

    let loading = this.$Loading
    loading.start()
    this.loading = true
    this.queryHandle()
    serviceEntrust.getPagesOfGenealogyApplyByEntrust(this.query)
      .then((pagers) => {
        console.log(pagers)
        this.tabledata = pagers.result!
      })
      .catch((err) => {
        this.$Message.error(err.message)
      })
      .finally(() => {
        loading.finish()
        this.loading = false
      })
  }

  queryHandle () {
    Object.keys(this.query).forEach((v) => {
      if (!this.query[v] || this.query[v] < 0) delete this.query[v]
    })
  }

  //  刷新当前页
  freshFromServer (): void {
    this.fetchDataFromServer()
  }

  onSearch () {
    this.fetchDataFromServer(1)
  }

  // 点击创建新的数据
  onNewItem () {
    this.modalRef && this.modalRef.openForNew({})
  }

  onViewItem (dataItem: GenealogyApply) {
    this.modalRef && this.modalRef.openForView(dataItem)
  }

  // 点击编辑数据
  onEditItem (dataItem: GenealogyApply) {
    this.modalRef && this.modalRef.openForModi(dataItem)
  }

  // 更新数据
  onUpdateItem (dataItem: GenealogyApply) {
  }

  onDelItem (dataItem: GenealogyApply) {
    return service.deleteOneGenealogyApply(dataItem.id!)
      .then(() => {
        this.$Message.success('删除成功')
        this.freshFromServer()
      }).catch(error => {
        this.$Message.error(error.message)
      })
  }
}
